import React from 'react'
import Footer from '../Common/Footer';
import SubNav from "../Common/SubNav";
import UserModify from '../Pages/UserModify'

const ProfileUpdate = (props) => {
    const { isShow, setIsShow } = props;
    return (
        <>
            <div className='h-screen w-full overflow-auto responsive_small'>
                <SubNav isShow={isShow} setIsShow={setIsShow} />

                <div className='items-center justify-center w-full h-screen overflow-auto p-4 bg-slate-100 '>
                    <h1 className='items bg-center py-3 text-2xl'>Profile Details</h1>
                    <div className='mb-3 border-t-sky-500 border-t-4 bg-white w-full items-center justify-center'>
                        <UserModify isShow={isShow} setIsShow={setIsShow} />
                    </div>
                </div>
                <Footer isShow={isShow} setIsShow={setIsShow} />

            </div>
        </>
    )
}

export default ProfileUpdate
